import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import OptionsDropdown from '../OptionsDropdown'
import DetailsLinks from '../DetailsLinks'
import VehicleInfo from './components/VehicleInfo'
import CompactVehicleInfo from '../CompactVehicleInfo'
import AddedItemsToCart from '../AddedItemsToCart'
import Link from 'components/common/Link/Link'
import { Selected, Circle, OptionsDwopdownWrapper } from '../../../SharedStyles'
import AvailableTires from 'components/common/AvailableTires'
import { LOADING } from 'constant'

const ActiveVehicle = ({
  nrOfItemsAddedToCart,
  deleteVehicle,
  openVehicleDeleteModal,
  openVehicleEditModal,
  isTrailer,
  isGenericTrailer,
  urlLinkToServiceHistory,
  urlLinkToViewCart,
  handleViewCartClick,
  searchByTireSizeUrl,
  handleUseThisVehicleClick,
  navigateToVehicleDetailsPage,
  isPilotStore,
  isNumberOfTiresLoading,
  ...props
}) => {
  const renderAvailableTires = isPilotStore && (!isTrailer && !isGenericTrailer)
    ? isNumberOfTiresLoading
      ? <LoadingText >{LOADING}</LoadingText>
      : <AvailableWrapper>
        <AvailableTires componentType="my-garage" />
      </AvailableWrapper>
    : null

  return (
    <Wrapper>
      <Selected data-at-garage-vehicle-selectedindicator>
        <Circle asset="check-circle" width={ 16 } height={ 16 } />
        Selected
      </Selected>
      <OptionsDwopdownWrapper>
        <OptionsDropdown
          openVehicleDeleteModal={ openVehicleDeleteModal }
          openVehicleEditModal={ openVehicleEditModal }
          deleteVehicle={ deleteVehicle }
          isTrailer={ isTrailer }
          isGenericTrailer={ isGenericTrailer } />
      </OptionsDwopdownWrapper>
      <Media.Desktop>
        <VehicleInfo
          isTrailer={ isTrailer }
          isGenericTrailer={ isGenericTrailer }
          openVehicleEditModal={ openVehicleEditModal }
          navigateToVehicleDetailsPage={ navigateToVehicleDetailsPage }
          { ...props } />
      </Media.Desktop>
      <Media.Mobile>
        <MobileVehicleInfo
          isTrailer={ isTrailer }
          isGenericTrailer={ isGenericTrailer }
          openVehicleEditModal={ openVehicleEditModal }
          navigateToVehicleDetailsPage={ navigateToVehicleDetailsPage }
          { ...props } />
      </Media.Mobile>
      {renderAvailableTires}
      {
        isTrailer &&
        <Link button data-at-garage-vehicle-shopbytiresize to={ searchByTireSizeUrl }>
          Shop Tires
        </Link>
      }
      {
        (!isTrailer && !isGenericTrailer) &&
        <DetailsLinksWrapper>
          <DetailsLinks
            activeVehicle
            navigateToVehicleDetailsPage={ navigateToVehicleDetailsPage }
            { ...props } />
        </DetailsLinksWrapper>
      }
      { Boolean(nrOfItemsAddedToCart) &&
      <CartLink
        urlLinkToViewCart={ urlLinkToViewCart }
        handleViewCartClick={ handleViewCartClick }
        nrOfItemsAddedToCart={ nrOfItemsAddedToCart } />
      }
    </Wrapper>
  )
}

export default ActiveVehicle

ActiveVehicle.propTypes = {
  deleteVehicle: PropTypes.bool,
  handleUseThisVehicleClick: PropTypes.func,
  handleViewCartClick: PropTypes.func,
  isGenericTrailer: PropTypes.bool,
  isNumberOfTiresLoading: PropTypes.bool,
  isPilotStore: PropTypes.bool,
  isTrailer: PropTypes.bool,
  masterVehicle: PropTypes.shape({
    makeDesc: PropTypes.string,
    modelDesc: PropTypes.string,
    subModelDesc: PropTypes.string,
    yearDesc: PropTypes.string
  }),
  mileage: PropTypes.string,
  navigateToVehicleDetailsPage: PropTypes.func,
  nrOfItemsAddedToCart: PropTypes.number,
  openVehicleDeleteModal: PropTypes.func,
  openVehicleEditModal: PropTypes.func,
  searchByTireSizeUrl: PropTypes.string,
  urlLinkToServiceHistory: PropTypes.string,
  urlLinkToViewCart: PropTypes.string,
  vehicleColor: PropTypes.string,
  vehicleName: PropTypes.string,
  vehicleNickname: PropTypes.string
}

const Wrapper = styled.div`
  grid-area: ActiveVehicle;
  padding: 69px 0 66px;
  background: ${Theme.colors.white};
  border: 1px solid ${Theme.colors.light_grey};
  border-radius: 4px;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${Media.mobile`
    display: block;
    padding: 69px 0 20px;
  `}
`

const MobileVehicleInfo = styled(CompactVehicleInfo)`
  margin: 0 0 20px 0;
  padding: 0 20px;
`

export const DetailsLinksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
  ${Media.mobile`
    flex-direction: row-reverse;
    justify-content: space-between;

    button {
      margin: 0;
    }

    &:first-child button {
      margin: 0 0 0 10px;
    }
  `}

  @media (max-width: 500px) {
    button,
    a {
      padding: 7px 1px 8px !important;
      font-size: 10px;
      width: 49%;
      margin: 0;
    }
  }
`

const CartLink = styled(AddedItemsToCart)`
  margin: 20px 0 0 0;
`

const sharedStyle = css`
  border-color: rgba(187, 187, 187, 1);
  border-style: solid;
  border-width: 1px 0 1px 0;
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
  padding: 19px 0;
  width: 100%;
`
const AvailableWrapper = styled.div`
  ${sharedStyle}
`

const LoadingText = styled.span`
  ${sharedStyle}
  font-size: 14px;
  ${Mixin.font.GothamBold()}
  line-height: 24px;
  ${Media.mediumMobile`
    font-size: 12px;
  `}
  ${Media.desktop`
    font-size: 16px;
  `}
  color: ${Theme.colors.medium_grey};
`
